import React from 'react';
import './emt-generated-content.scss';
import PropTypes from 'prop-types';
import { params, useDataModel } from '@thd-nucleus/data-sources';
import { Heading } from '@thd-olt-component-react/core-ui';
import { string as stringType, shape as shapeType } from '@thd-nucleus/data-sources/react/dataModel/prop-types';
import { ProductCategoryContent } from './ProductCategoryContent';
import { MarketingQuestionAnswer } from './MarketingQuestionAnswer';

export const EmtGeneratedContent = (props) => {
  const { nvalue = '', type } = props;
  let nval = (nvalue?.indexOf('N-') < 0) ? `N-${nvalue}` : nvalue;
  const { loading, data, error } = useDataModel('emtGeneratedContent', { variables: { nvalue: nval }, skip: !nval });
  if ((error && !data) || loading || !data?.emtGeneratedContent) { return null; }
  let questionAndAnswers = [];
  switch (type) {
  case 'productCategoryContent':
    return <ProductCategoryContent content={data?.emtGeneratedContent?.productCategoryContent} />;
  case 'questionsAndAnswers':
    try {
      let jsonContent = JSON.parse(data?.emtGeneratedContent?.questionAndAnswer);
      questionAndAnswers = jsonContent.Questions;
    } catch (err) {
      return null;
    }
    if (!questionAndAnswers || questionAndAnswers.length === 0) { return null; }
    return (
      <div>
        <Heading title="Questions & Answers" underline />
        <MarketingQuestionAnswer qaSets={questionAndAnswers} />
      </div>
    );
  default:
    return null;
  }

};
EmtGeneratedContent.displayName = 'EmtGeneratedContent';

EmtGeneratedContent.defaultProps = {
  type: 'questionsAndAnswers'
};

EmtGeneratedContent.propTypes = {
  nvalue: PropTypes.string.isRequired,
  type: PropTypes.string
};

const paramsForQuery = params({ nvalue: stringType().isRequired() });
EmtGeneratedContent.dataModel = {
  emtGeneratedContent: paramsForQuery.shape({
    questionAndAnswer: stringType(),
    productCategoryContent: shapeType({
      title: stringType(),
      data: stringType()
    })
  })
};
